<!-- Job Selection -->
<label><strong>Job:</strong></label>
<ng-select
  #jobSelect
  id="job"
  [items]="jobList()"
  [ngModel]="selectedJob()"
  (ngModelChange)="jobChanged($event)"
  bindLabel="DisplayValue"
  [searchable]="true"
  [searchFn]="searchJobs"
  [clearable]="false"
  style="margin-bottom: 12px;"
>
  <ng-template ng-option-tmp let-item="item">
    <span [title]="item.DisplayValue || item.JobDisplayName">{{ item.DisplayValue || item.JobDisplayName }}</span>
  </ng-template>
</ng-select>

<!-- Phase Selection -->
<label><strong>Phase:</strong></label>
<ng-select
  #phaseSelect
  id="phase"
  [items]="phaseList()"
  [ngModel]="selectedPhase()"
  (ngModelChange)="phaseChanged($event)"
  bindLabel="PhaseDescription"
  [searchable]="true"
  [searchFn]="searchPhases"
  [clearable]="false"
  [disabled]="phaseList().length === 0"
  style="margin-bottom: 12px;"
>
  <ng-template ng-option-tmp let-item="item">
    <span [title]="item.PhaseDescription">{{ item.PhaseDescription }}</span>
  </ng-template>
</ng-select>

<!-- Equipment Selection (Conditional) -->
<ng-container *ngIf="enableEquipmentLookup()">
  <label><strong>Equipment:</strong></label>
  <ng-select
    #equipmentSelect
    id="equipment"
    [items]="equipmentList()"
    [ngModel]="selectedEquipment()"
    (ngModelChange)="equipmentChanged($event)"
    bindLabel="DisplayValue"
    [typeahead]="equipmentInput$"
    [searchable]="true"
    [clearable]="true"
    typeToSearchText="Please enter 3 or more characters"
    placeholder="Type to search..."
    style="margin-bottom: 12px;"
  >
    <ng-template ng-option-tmp let-item="item">
      <span [title]="item.DisplayValue">{{ item.DisplayValue }}</span>
    </ng-template>
  </ng-select>
</ng-container>
